import { IClientPropalModel, IClientPropalPeriodeModel } from "@common-models/*"
import React, { useState } from "react"
import MyTooltip from "@common-utils/MyTooltip"
import PtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtf from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtf"
import PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommande from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommande"
import MyModal from "@common-utils/MyModal"
import PtfProlongementForm from "../actions/_PtfProlongementForm"
import { IGetPeriodesBonsCommandeBonsLivraisonResponseModel } from "../core/_models"
import { usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext } from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison"
import { useQueryClient } from "react-query"
import { deletePropalPeriodeRequest } from "../core/_requests"
import { toast } from "react-toastify"
import swal from "sweetalert2"
import PtfPeriodeEditForm from "../actions/_PtfPeriodeEditForm"

const PtfDetailsPeriodesBonsCommandeBonsLivraison_Periodes = ({ ptf }: IPtfDetailsPeriodesBonsCommandeBonsLivraison_PeriodesPropsModel) => {
     const context = usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext()
     const queryClient = useQueryClient()

     const [prolongementPtf, setProlongementPtf] = useState<{
          ptf: IClientPropalModel
          modalTitle: JSX.Element
          isModalFullScreen?: true
     }>()

     const [editPeriodeInModal, setEditPeriodeInModal] = useState<IClientPropalPeriodeModel>()

     function handleSubmitProlongementCallback(val: IClientPropalPeriodeModel) {
          setProlongementPtf(prev =>
               prev
                    ? {
                           ...prev,
                           isModalFullScreen: true,
                           modalTitle: (
                                <div className={"d-flex"}>
                                     <div>Édition de la {val.reference}A</div>
                                     <button className={"btn btn-sm btn-success p-0 px-2 py-1 d-flex align-items-center ms-2"} onClick={() => setProlongementPtf(undefined)}>
                                          Terminer <i className={"fas fa-check-cirle ms-1"} />
                                     </button>
                                </div>
                           ),
                      }
                    : undefined
          )
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         prev.data.map(item => {
                              if (item.id === ptf.id) {
                                   item.clientPropalPeriodes = [val, ...(item.clientPropalPeriodes || [])]
                                   return item
                              }
                         })
                         return prev
                    }
                    return prev
               }
          )
     }

     function handleRemovePeriode(id: number) {
          swal.fire({
               icon: "warning",
               text: `Voulez-vous vraiment supprimer cette période ?`,
               showCancelButton: true,
               confirmButtonText: "Oui",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    return deletePropalPeriodeRequest(id)
                         .then(() => {
                              queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
                                   context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
                                   (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                                        if (prev?.data) {
                                             prev.data.map(item => {
                                                  item.clientPropalPeriodes?.map(item_ => {
                                                       if (item_.id === id) {
                                                            item.clientPropalPeriodes = item.clientPropalPeriodes?.filter(item__ => item__.id !== id)
                                                       }
                                                  })
                                                  return item
                                             })
                                             return prev
                                        }
                                        return prev
                                   }
                              )
                              toast.info("La période a bien été supprimée.")
                         })
                         .catch(e => {
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !swal.isLoading(),
          }).then()
     }

     function handleSubmitEditPeriodeCallback(val: IClientPropalPeriodeModel) {
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         prev.data.map(item => {
                              item.clientPropalPeriodes?.map(item_ => {
                                   if (item_.id === editPeriodeInModal?.id) {
                                        item_.dateDebutValidite = val.dateDebutValidite
                                        item_.dateFinValidite = val.dateFinValidite
                                        return item_
                                   }
                              })
                         })
                    }
                    return prev
               }
          )

          setEditPeriodeInModal(undefined)
     }

     return (
          <>
               {ptf.clientPropalPeriodes?.map((periode, index) => (
                    <div className="card shadow-sm mb-10" key={index}>
                         {/* Card Header with Custom Style for better hierarchy */}
                         <div className="card-header border-0 pt-5 ribbon ribbon-end ribbon-clip">
                              <div className="card-title d-flex align-items-center">
                                   <div className="symbol symbol-50px me-4">
                                        <div className="symbol-label bg-light-info border border-info border-dashed">
                                             <span className="fas fa-calendar-alt text-info fs-2" />
                                        </div>
                                   </div>
                                   <div className="d-flex flex-column">
                                        <span className="fs-4 fw-bolder text-gray-900 mb-1">Période {periode.reference}</span>
                                        <div className="text-muted fw-bold fs-7">
                                             {periode.dateDebutValidite?.format("D MMMM YYYY")} - {periode.dateFinValidite?.format("D MMMM YYYY")}
                                        </div>
                                   </div>
                              </div>

                              <div className="card-toolbar gap-2">
                                   {index === 0 && (
                                        <button
                                             className="btn btn-sm btn-light-success fw-bold me-2 hover-elevate-up"
                                             onClick={() =>
                                                  setProlongementPtf({
                                                       ptf,
                                                       modalTitle: (
                                                            <span>
                                                                 {`${ptf.reference}-${ptf.clientPropalPeriodes!.length}`} {"-->"}
                                                                 {`${ptf.reference}-${ptf.clientPropalPeriodes!.length + 1}`}
                                                            </span>
                                                       ),
                                                  })
                                             }
                                        >
                                             <i className="fas fa-plus-circle fs-5 me-1"></i> Prolonger
                                        </button>
                                   )}

                                   <div className="d-flex gap-1">
                                        <MyTooltip title={"Modifier la période"}>
                                             <button className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary" onClick={() => setEditPeriodeInModal(periode)}>
                                                  <i className={"fas fa-pencil-alt fs-5"} />
                                             </button>
                                        </MyTooltip>
                                        <MyTooltip title={"Supprimer la période"}>
                                             <button className="btn btn-sm btn-icon btn-bg-light btn-active-color-danger" onClick={() => handleRemovePeriode(periode.id as number)}>
                                                  <i className={"fas fa-trash fs-5"} />
                                             </button>
                                        </MyTooltip>
                                   </div>
                              </div>
                         </div>

                         <div className="card-body pt-3 pb-8">
                              <div className="separator separator-dashed my-4"></div>

                              <div className="row g-10">
                                   {/* Left Column: Versions (Context) */}
                                   <div className="col-lg-12">
                                        <PtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtf periode={periode} />
                                   </div>

                                   {/* Full Width: Content */}
                                   <div className="col-lg-12">
                                        <PtfDetailsPeriodesBonsCommandeBonsLivraison_BonsCommande periode={periode} ptf_type={ptf.type as string} />
                                   </div>
                              </div>
                         </div>
                    </div>
               ))}

               {/* Modal add version PTF */}
               {prolongementPtf && (
                    <MyModal
                         title={prolongementPtf.modalTitle}
                         show={true}
                         onCloseCallback={() => setProlongementPtf(undefined)}
                         size={"lg"}
                         fullscreen={prolongementPtf.isModalFullScreen}
                         noPadding={prolongementPtf.isModalFullScreen}
                    >
                         <PtfProlongementForm ptf_ID={ptf!.id as number} handleSubmitCallback={handleSubmitProlongementCallback} />
                    </MyModal>
               )}

               {/* Modal edit PÉRIODE */}
               {editPeriodeInModal && (
                    <MyModal
                         title={
                              <>
                                   Période du {editPeriodeInModal.dateDebutValidite?.format("D MMM YYYY")} au {editPeriodeInModal.dateFinValidite?.format("D MMM YYYY")}
                              </>
                         }
                         show={true}
                         onCloseCallback={() => setEditPeriodeInModal(undefined)}
                         size={"lg"}
                    >
                         <PtfPeriodeEditForm periode={editPeriodeInModal} handleSubmitCallback={handleSubmitEditPeriodeCallback} />
                    </MyModal>
               )}
          </>
     )
}

interface IPtfDetailsPeriodesBonsCommandeBonsLivraison_PeriodesPropsModel {
     ptf: IClientPropalModel
}

export default PtfDetailsPeriodesBonsCommandeBonsLivraison_Periodes
